import type React from 'react';

const EducationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.8432 2.25641H16.074V8.82051C16.074 10.0677 15.0648 11.0769 13.8176 11.0769H9.50992V13.3251L13.2268 14.8103C13.5386 14.9333 13.6945 15.2944 13.5715 15.6062C13.473 15.8441 13.2432 15.9918 12.9971 15.9918C12.9232 15.9918 12.8412 15.9754 12.7674 15.9508L8.89453 14.4L5.02171 15.9508C4.70992 16.0738 4.34889 15.9262 4.22581 15.6062C4.10274 15.2944 4.25043 14.9333 4.57043 14.8103L8.28735 13.3251V11.0769H3.97145C2.72427 11.0769 1.71504 10.0677 1.71504 8.82051V2.25641H2.94581V8.82051C2.94581 9.38667 3.4053 9.84615 3.97145 9.84615H13.8176C14.3838 9.84615 14.8432 9.38667 14.8432 8.82051V2.25641ZM16.2791 0H1.50992C1.17351 0 0.894531 0.278974 0.894531 0.615385C0.894531 0.951795 1.17351 1.23077 1.50992 1.23077H16.2791C16.6156 1.23077 16.8945 0.951795 16.8945 0.615385C16.8945 0.278974 16.6156 0 16.2791 0ZM6.40838 8.02462C6.53145 8.14769 6.68735 8.20513 6.84325 8.20513C6.99915 8.20513 7.15504 8.14769 7.27812 8.02462L10.3304 4.97231V6.76923C10.3304 7.10564 10.6094 7.38462 10.9458 7.38462C11.2822 7.38462 11.5612 7.10564 11.5612 6.76923V3.48718C11.5612 3.15077 11.2822 2.87179 10.9458 2.87179H7.66376C7.32735 2.87179 7.04838 3.15077 7.04838 3.48718C7.04838 3.82359 7.32735 4.10256 7.66376 4.10256H9.46068L6.40838 7.15487C6.17043 7.39282 6.17043 7.78667 6.40838 8.02462Z"
      fill="#0784BE"
    />
  </svg>
);

export default EducationIcon;
